export var EComputerActiveState;
(function (EComputerActiveState) {
    EComputerActiveState[EComputerActiveState["Invalid"] = 0] = "Invalid";
    EComputerActiveState[EComputerActiveState["Active"] = 1] = "Active";
    EComputerActiveState[EComputerActiveState["Idle"] = 2] = "Idle";
})(EComputerActiveState || (EComputerActiveState = {}));
